import { useState } from 'react';

import { faSliders } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans, useLingui } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@repo/videa-components/src/ui/dialog';

import { ToolbarButton } from '../imageToolbar/ToolbarButton';

import { ConfidencePreferenceV2 } from './ConfidencePreferenceV2';

interface ConfidenceSettingsProps {
  isEmbedded?: boolean;
  showPreferenceButton?: boolean;
}

export const ConfidenceDialog = (props: ConfidenceSettingsProps) => {
  const { isEmbedded, showPreferenceButton } = props;
  const [isConfidenceDialogOpen, setIsConfidenceDialogOpen] = useState(false);
  const { t } = useLingui();

  const setConfidencePrefOpen = (isOpen: boolean) => {
    setIsConfidenceDialogOpen(isOpen);
  };

  return isEmbedded ? (
    <ConfidencePreferenceV2 isEmbedded />
  ) : (
    <>
      {showPreferenceButton ? (
        <div className="vai-flex vai-px-6 vai-justify-between pref-button-set vai-gap-4">
          <Button
            variant="outline"
            className="hover:vai-bg-blue-200 vai-border-blue-300 vai-text-blue-800"
            onClick={() => setConfidencePrefOpen(true)}
          >
            <FontAwesomeIcon icon={faSliders} />
            <Trans>Display Threshold Setting</Trans>
          </Button>
        </div>
      ) : (
        <div className="confidence-settings-button">
          <ToolbarButton
            dataCy="confidence-settings-button"
            title={t`Display Threshold Setting`}
            isActive={isConfidenceDialogOpen}
            onClick={() => setConfidencePrefOpen(true)}
          >
            <FontAwesomeIcon icon={faSliders} />
          </ToolbarButton>
        </div>
      )}

      <Dialog
        open={isConfidenceDialogOpen}
        onOpenChange={setConfidencePrefOpen}
      >
        <DialogContent className="vai-max-w-6xl vai-max-h-[90vh] vai-overflow-y-auto vai-min-w-0">
          <DialogHeader>
            <DialogTitle>
              <Trans>Display Threshold Preference</Trans>
            </DialogTitle>
          </DialogHeader>

          <div className="vai-text-center">
            <p className="vai-text-sm vai-text-foreground vai-max-w-[55em] vai-mx-auto vai-my-8">
              <Trans>
                Please select your default threshold for possible pathology
                display. (You can always change it again later, for your
                practice or just for a radiograph.) NOTE: This change will
                affect all users across your practice. You or another user can
                adjust it at any time.{' '}
                <strong>
                  Confer with your providers to decide which settings changes to
                  make.
                </strong>
              </Trans>
            </p>

            <ConfidencePreferenceV2
              setConfidencePrefOpen={setConfidencePrefOpen}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
